export default __webpack_public_path__ + "static/media/watch.e6f74fd0.svg";